// extracted by mini-css-extract-plugin
module.exports = {"load_delivery_container":"LoadDeliveriesList_load_delivery_container__1kVZw"};